import { getValue, update } from '@kundinos/nanostores';
import equal from 'fast-deep-equal';

import ApiProduct from '@Api/Product';
import * as PageProduct from '@Stores/PageProduct';
import { DIContainer } from '@Contexts/DI';
import { currentParametersStore, dataStore } from './stores';

import type { Parameter } from '@Pages/PageProduct';

function getNameOfParameter(parameter: Parameter) {
  return (parameter.title || '').split(':')[0];
}

const updateData = async () => {
  const { logger } = DIContainer.getDeps();
  const data = getValue(dataStore);
  const parameterValues = PageProduct.getParameterValues();
  const params = { shopProductId: data.product.id, parameterValues };

  try {
    const res = await ApiProduct.getInfoByParams(params);
    const currentParameters = getValue(currentParametersStore);
    let newParameters = currentParameters;

    /**
     * TODO:
     * Единственный способ найти параметр, который нужно обновить это его название
     * Но лучше бы реализовать поиск параметров по идентификаторам
     */
    (res.parameters || []).forEach((resParam) => {
      const name = getNameOfParameter(resParam);

      newParameters = currentParameters.map((currentParam) => {
        const prevName = getNameOfParameter(currentParam);

        return prevName === name ? resParam : currentParam;
      });
    });

    update(dataStore, (prev) => {
      let cylindo = prev.cylindo;

      if (cylindo) {
        const featureMap = {};
        const features = cylindo.features || [];
        const paramsMap = {};

        currentParameters.forEach((item) => {
          (item.variants || []).forEach((variant) => {
            if (!variant.selected || !variant.featureName || !variant.featureId) return;

            paramsMap[variant.featureName] = variant.featureId;
          });
        });

        for (let i = 0; i < features.length; i += 2) {
          featureMap[features[i]] = features[i + 1];
        }

        const objVariants = { ...featureMap, ...paramsMap };
        const arrVariants: Array<[string, string]> = Object.entries(objVariants);
        const variants: string[] = arrVariants.flat();

        cylindo = {
          ...cylindo,
          features: variants,
        };
      }

      let promoCode = null;

      if (prev.promoCode) {
        promoCode = { ...prev.promoCode };
      }

      if (res.promoCode) {
        promoCode = { ...promoCode, ...res.promoCode };
      }

      return {
        ...prev,
        product: {
          ...data.product,
          price: { ...prev.product.price, ...res.price },
        },
        credit: res.credit || prev.credit,
        promoCode,
        cylindo,
        blocked: true,
      };
    });

    if (!equal(currentParameters, newParameters)) {
      update(currentParametersStore, () => newParameters);
    }

    update(dataStore, (prev) => ({ ...prev, blocked: false }));
  } catch (err) {
    logger.log(err);
  }
};

export default updateData;
